
import "./messagePopup.css";
import { useState, useEffect } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import { Msgdetails } from '../feedbackAppTab/_models/msgdetails-model'
import { useData } from "@microsoft/teamsfx-react";
import { useTeamsUserCredential } from "@microsoft/teamsfx-react";
import {
    FluentProvider,
    teamsLightTheme,
    teamsDarkTheme,
    teamsHighContrastTheme,
    tokens,
  } from "@fluentui/react-components";
import config from "../lib/config";

interface IInputData {
    msgdetails: Msgdetails
}
// export const MessagePopup = (props: IInputData) => {
//     return (
//         <div>Message PopUp
//             <div>{props.msgdetails.message}</div>
//         </div>

//     )
// }
export const MessagePopup = (props: IInputData) => {

    const { loading, theme, themeString, teamsUserCredential } = useTeamsUserCredential({
        initiateLoginEndpoint: config.initiateLoginEndpoint!,
        clientId: config.clientId!,
      });
    const lightTheme = {
        palette: {
            themePrimary: '#0078d4',
            themeLighterAlt: '#eff6fc',
            themeLighter: '#deecf9',
            themeLight: '#c7e0f4',
            themeTertiary: '#71afe5',
            themeSecondary: '#2b88d8',
            themeDarkAlt: '#106ebe',
            themeDark: '#005a9e',
            themeDarker: '#004578',
            neutralLighterAlt: '#eee9e9',
            neutralLighter: '#eae6e6',
            neutralLight: '#e1dcdc',
            neutralQuaternaryAlt: '#d1cdcd',
            neutralQuaternary: '#c8c4c4',
            neutralTertiaryAlt: '#c0bcbc',
            neutralTertiary: '#a19f9d',
            neutralSecondary: '#605e5c',
            neutralPrimaryAlt: '#3b3a39',
            neutralPrimary: '#323130',
            neutralDark: '#201f1e',
            black: '#000000',
            white: '#f5f1f1',
        }
    };
    const darktheme = {
        palette: {
            themePrimary: '#0078d4',
            themeLighterAlt: '#eff6fc',
            themeLighter: '#deecf9',
            themeLight: '#c7e0f4',
            themeTertiary: '#71afe5',
            themeSecondary: '#2b88d8',
            themeDarkAlt: '#106ebe',
            themeDark: '#005a9e',
            themeDarker: '#004578',
            neutralLighterAlt: '#323130',
            neutralLighter: '#31302f',
            neutralLight: '#2f2e2d',
            neutralQuaternaryAlt: '#2c2b2a',
            neutralQuaternary: '#2a2928',
            neutralTertiaryAlt: '#282726',
            neutralTertiary: '#c8c8c8',
            neutralSecondary: '#d0d0d0',
            neutralPrimaryAlt: '#dadada',
            neutralPrimary: '#ffffff',
            neutralDark: '#f4f4f4',
            black: '#f8f8f8',
            white: '#323130',
        }
    };
    const contrastTheme = ({
        palette: {
            themePrimary: '#ffffff',
            themeLighterAlt: '#767676',
            themeLighter: '#a6a6a6',
            themeLight: '#c8c8c8',
            themeTertiary: '#d0d0d0',
            themeSecondary: '#dadada',
            themeDarkAlt: '#eaeaea',
            themeDark: '#f4f4f4',
            themeDarker: '#f8f8f8',
            neutralLighterAlt: '#0b0b0b',
            neutralLighter: '#151515',
            neutralLight: '#252525',
            neutralQuaternaryAlt: '#2f2f2f',
            neutralQuaternary: '#373737',
            neutralTertiaryAlt: '#595959',
            neutralTertiary: '#ffffb3',
            neutralSecondary: '#ffff66',
            neutralPrimaryAlt: '#ffff1f',
            neutralPrimary: '#ffff01',
            neutralDark: '#c2c200',
            black: '#8f8f00',
            white: '#000000',
        }
    });
    const EIdashboardURL = 'Welcome URL';
    const [currentTheme, setThemeState] = useState(lightTheme);
    const [isLightTheme, setLightTheme] = useState(true);
    const [isInMeeting, setInMeeting] = useState(false);


    useEffect(() => {

        console.log("msgdata: ", props);
    }, []);

    useEffect(()=>{
        if (themeString == 'dark')
        {
            setThemeState(darktheme);
            setLightTheme(false);
            console.log("LightTheme Value in dark:" + isLightTheme);
        }
        else if (themeString == 'contrast')
        {
            setThemeState(contrastTheme);
            setLightTheme(false);
            console.log("LightTheme Value in contrast:" + isLightTheme);
        }
        else
        {
            setThemeState(lightTheme);
            setLightTheme(true);
            console.log("LightTheme Value in default:" + isLightTheme);
        }
    },[themeString])
    // useEffect(() => {
    //     microsoftTeams.app.initialize();
    //     microsoftTeams.app.notifySuccess();
    //     microsoftTeams.registerOnThemeChangeHandler((theme: string) => {

    //         console.log(`theme changed to: ${theme}`);
    //         console.log("is In Meeting Variable val:" + isInMeeting);
    //         console.log("Theme Set successfully!");
    //         //Update the themeState with the new theme.

    //         if (theme === 'dark') {
    //             setThemeState(darktheme);
    //             setLightTheme(false);
    //             console.log("LightTheme Value in dark:" + isLightTheme);
    //         }
    //         else if (theme === 'contrast') {
    //             setThemeState(contrastTheme);
    //             setLightTheme(false);
    //             console.log("LightTheme Value in contrast:" + isLightTheme);
    //         }
    //         else {
    //             setThemeState(lightTheme);
    //             setLightTheme(true);
    //             console.log("LightTheme Value in default:" + isLightTheme);
    //         }

    //     });
    // }, [inTeams]);

    const appInfo = useData(async ()=>
        {
            microsoftTeams.app.initialize();
            return microsoftTeams.app.getContext();
        }).data;

    console.log("AppInfo",appInfo);

    useEffect(()=>{
        if (appInfo?.page?.frameContext === 'sidePanel') 
        {
            setLightTheme(false);
            setInMeeting(true);

            console.log("is In Meeting set to true val->:" + isInMeeting);
        }
        else
        {
            if (themeString === 'dark') {
                setThemeState(darktheme);
                setLightTheme(false);
                setInMeeting(false);
            }
            else if (themeString === 'contrast') {
                setThemeState(contrastTheme);
                setLightTheme(false);
                setInMeeting(false);
            }
            else {
                setThemeState(lightTheme);
                setLightTheme(true);
                setInMeeting(false);
            }

        }
    }, [appInfo, themeString])
    // useEffect(() => {
    //     if (appInfo != undefined) {
    //         console.log(`Current theme is ->: ${appInfo.page.theme}`);
    //         if (context.frameContext === 'sidePanel') {
    //             setLightTheme(false);
    //             setInMeeting(true);

    //             console.log("is In Meeting set to true val->:" + isInMeeting);
    //         }
    //         else {
    //             if (context.theme === 'dark') {
    //                 setThemeState(darktheme);
    //                 setLightTheme(false);
    //                 setInMeeting(false);
    //             }
    //             else if (context.theme === 'contrast') {
    //                 setThemeState(contrastTheme);
    //                 setLightTheme(false);
    //                 setInMeeting(false);
    //             }
    //             else {
    //                 setThemeState(lightTheme);
    //                 setLightTheme(true);
    //                 setInMeeting(false);
    //             }
    //         }

    //     }

    // }, [appInfo]);


    /**
     * The render() method to create the UI of the tab
     */
    return (
        <div className={(isInMeeting ? 'app_Msgdiv_Inmeeting' : isLightTheme ? "app_Msgdiv" : "app_Msgdiv_dark")}>
            <div>
                <div style={{  display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"
                }}>
                    <div>
                        <div className={(isInMeeting ? 'child_container_msgbox-inMeeting' : isLightTheme ? 'child_container_msgbox' : 'child_container_msgbox_dark')} >
                            <div><img id="infoimg" src={props.msgdetails.iconpath} alt="Info" /></div>
                            <div className="div_blue">{props.msgdetails.msgType}</div>
                            <span className="div_info">{props.msgdetails.message}</span>
                            <span className="div_hyperlink"><a target='_blank' rel="noopener noreferrer" href={EIdashboardURL}>{props.msgdetails.hyperlink}</a></span>
                            <span className="div_info">{props.msgdetails.afterlinkmsg}</span>
                        </div>

                    </div>
                </div>
            </div >
        </div>
    );
};